<template>
  <div class="select-com" :style="{ width }">
    <el-select
      :value="value"
      :clearable="clearable"
      @input="onInput"
      :placeholder="placeholder"
      :size="size"
      :disabled="disabled"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'SelectCom',
  props: {
    placeholder: {
      type: String,
      default: '请选择',
    },
    value: {
      type: [String, Number],
      required: true,
      default: '',
    },
    options: {
      type: Array,
      required: true,
      default() {
        return []
      },
    },
    size: {
      type: String,
      default: 'medium',
    },
    width: {
      type: String,
      default: '200px',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onInput(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style lang='scss'>
.select-com {
  .el-select {
    width: 100%;
  }
}
</style>